import React, { useEffect, useState } from 'react';

import PubSub from '@aws-amplify/pubsub';
import {
  Authenticator,
  SignIn as AwsSignIn,
  Greetings,
} from 'aws-amplify-react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { anniversary } from '../src/images';
// import CustomChatbot from './components/chatbot/CustomChatbot';
import authenticatorConfig from './config/authenticatorConfig';
import { getCustomerSubscriptionInfo } from './graphql';
// import { notifications } from './graphql/subscriptions';
import configureStore from './redux/configureStore';
import { setUserProfile } from './redux/reducers/user';
import Routes from './Routes';
import './App.css';
import { useTheme } from './ThemeContext';
import { googleAnalyticsUpdateUserInfo } from './utils/AnalyticsHelper';
import EmojiBurstEffect from './views/emojiBurst';
// import NotificationContainer from './views/Notifications/NotificationContainer';
const { persistor, store } = configureStore();

// Amplify.configure(authenticatorConfig);
// Amplify.Logger.LOG_LEVEL = 'DEBUG';

PubSub.configure(authenticatorConfig);

const App: React.FC = (Props) => {
  const { setTheme } = useTheme();
  const [showHoliEffect, setShowHoliEffect] = useState(true);
  const loadProfile = async (authState: string): Promise<any> => {
    let promises: Array<any> = [];
    if (authState === 'signedIn') {
      googleAnalyticsUpdateUserInfo();
      // subscription testing
      // const subscription = API.graphql(
      //   graphqlOperation(notifications, {
      //     email: 'vishal.0694@gmail.com',
      //     body: 'Check Out Our New Refer And Earn Program',
      //   }),
      // );
      // subscription.subscribe({
      //   next: (value) => setText(value),
      //   error: (error) => console.warn(error),
      // });
      const user = await getCustomerSubscriptionInfo();
      console.log('UserInfo', user);
      promises.concat([store.dispatch(setUserProfile(user))]);
    }
    return Promise.all(promises);
  };
  useEffect(() => {
    // Sentry.init({
    //   dsn: process.env.REACT_APP_SENTRY,
    //   autoSessionTracking: true,
    //   integrations: [new Integrations.BrowserTracing()],
    //   environment: process.env.REACT_APP_ENVIRONMENT,

    //   // We recommend adjusting this value in production, or using tracesSampler
    //   // for finer control
    //   tracesSampleRate: 1.0,
    // });
    const defaultTheme = localStorage.getItem('theme') || 'dark';
    setTheme(defaultTheme);
    setTimeout(() => {
      setShowHoliEffect(false);
    }, 10000);

    // Inject Chatbot Script
    const chatScript = document.createElement('script');
    chatScript.async = true;
    chatScript.setAttribute('data-id', '1516136643');
    chatScript.id = 'chatling-embed-script';
    chatScript.type = 'text/javascript';
    chatScript.src = 'https://chatling.ai/js/embed.js';
    document.body.appendChild(chatScript);
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {showHoliEffect && (
          <>
            <EmojiBurstEffect />
            <div className="anniversary-container">
              <div className="anniversary-content">
                <div className="anniversary-card">
                  <img
                    src={anniversary}
                    alt="ThinkSabio Anniversary Logo"
                    className="anniversary-logo"
                  />
                  <h1 className="anniversary-title gradient-text">
                    🎉Happy Anniversary, ThinkSabiens!🎉
                  </h1>
                  <p className="anniversary-subtitle gradient-subtext">
                    In a market of candlesticks and catalysts, your trust was
                    our breakout.
                  </p>
                  <p className="anniversary-subtitle gradient-subtext">
                    Here’s to 7 bold years of insight, resilience, and
                    growth—together.
                  </p>

                  <p className="anniversary-message">
                    📈 Thank you for standing with us through every trend, dip,
                    and rally.
                  </p>
                </div>
              </div>

              {/* Color bursts (optional) */}
              <div className="anniversary-burst anniversary-top"></div>
              <div className="anniversary-burst anniversary-bottom"></div>
              <div className="anniversary-burst anniversary-left"></div>
              <div className="anniversary-burst anniversary-right"></div>
            </div>
          </>
        )}
        <Authenticator
          hide={[AwsSignIn, Greetings]}
          amplifyConfig={authenticatorConfig}
          onStateChange={loadProfile}
        >
          <Routes />
          {/*<div style={{ bottom: '100px' }}>*/}
          {/*  <CustomChatbot />*/}
          {/*</div>*/}
          {/*<NotificationContainer />*/}
        </Authenticator>
      </PersistGate>
    </Provider>
  );
};

export default App;
